import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import HandleAuthContext from 'contexts/AuthContext';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <HandleAuthContext>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: '',
          duration: 4000,
          style: {
            background: '#f4f7fe',
            color: '#422afb',
            height: '75px',
            padding: '10px 20px',
            fontSize: '100%',
            fontWeight: 'bold',
            whiteSpace: 'nowrap', // Ensure text does not wrap to the next line
            overflow: 'hidden', // Hide overflowing content
            textOverflow: 'ellipsis', // Add ellipsis (...) to indicate overflow
          },
          success: {
            duration: 2000,
            theme: {
              primary: 'green',
              secondary: 'black',
            },
          },
        }}
      />

      <App />
    </HandleAuthContext>
  </BrowserRouter>
);
